import * as THREE from "three"

import Experience from "../Experience.js";
import Environment from "./Environment.js";
import Console from "./Console.js";
import Background from "./Background.js";
// import Statistics from "./Statistics.js";
import Raycasting from "../Raycasting.js";


export default class World {

    constructor() {

        this.experience = new Experience()

        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.debug = this.experience.debug
        this.background = new Background()
        // this.stats = new Statistics()
        




        this.resources.on("ready", () => {
            this.console = new Console()
            this.environment = new Environment()
            this.raycasting = new Raycasting(this.console.consoleParts, this.console.hitTargets)


            // Setup Screen
            if (this.experience.screen) {
                this.experience.screen.setModel(this.console.screenMesh)
            }
        })


    }

    update() {
        if (this.stats) {
            this.stats.update()
        }

        if (this.background) {
            this.background.update()
        }

        if (this.console) {
            this.console.update()
        }
        if (this.raycasting) {
            this.raycasting.update()
        }
    }
}
